<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :model="formLabelAlign"
    >
      <el-form-item label="名字">
        <el-input
          v-model="formLabelAlign.name"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-input
          v-model="formLabelAlign.path"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { settingstore, settingupdate } from '@/api/sourceminiprogram.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        path: '',
        name: ''
      },
      type: null,
      id: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    sumbit() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请输入名字')
        return
      }
      if (this.formLabelAlign.name === null) {
        this.$message.error('请输入名字')
        return
      }
      if (this.formLabelAlign.path === '') {
        this.$message.error('请输入地址')
        return
      }
      if (this.type === 1) {
        settingstore(this.formLabelAlign).then(res => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      } else {
        settingupdate({ ...this.formLabelAlign, id: this.id }).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      }
    },
    send(type, item) {
      this.type = type
      if (this.type === 2) {
        this.formLabelAlign.path = item.path
        this.formLabelAlign.name = item.name
        this.id = item.id
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
